// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   LILLY HEADER
   ========================================================= */

.lilly-header-wrapper {
  width: 100%;
  position: relative;
  z-index: 100;
}

/*
 * Main Lilly red header
 */

.lilly-header-wrapper .navbar,
.lilly-header-wrapper nav {
  background: #d52b1e !important;
  border: none !important;
}

/*
 * Header container
 */

.lilly-header {
  position: relative;
  height: 64px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  color: #ffffff;
  background: #d52b1e;
}

/* =========================================================
   LEFT
   ========================================================= */

.lilly-header-left {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.lilly-brand-area {
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 0 20px 0 12px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.lilly-clickable {
  cursor: pointer;
}

.lilly-brand-area:hover {
  background: rgba(255, 255, 255, 0.08);
}

.lilly-back-icon {
  width: 26px;
  height: 26px;
  margin-right: 14px;
  color: #ffffff !important;
  stroke-width: 2;
}

.lilly-logo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

/*
 * Try to make the existing OHIF logo white.
 * If your custom Lilly logo already handles this,
 * these rules can be removed.
 */

.lilly-logo svg {
  max-height: 38px;
  width: auto;
  color: #ffffff;
  fill: #ffffff;
}

/* =========================================================
   SECONDARY
   ========================================================= */

.lilly-secondary {
  position: absolute;
  left: 250px;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 40px;
  color: #ffffff;
}

/* Ensure secondary components don't get black text */

.lilly-secondary,
.lilly-secondary * {
  color: #ffffff;
}

/* =========================================================
   CENTER
   ========================================================= */

.lilly-header-center {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  max-width: 45%;
}

.lilly-center-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 8px;
  color: #ffffff;
}

.lilly-center-content * {
  color: #ffffff;
}

/* =========================================================
   RIGHT
   ========================================================= */

.lilly-header-right {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  padding-right: 10px;
}

.lilly-control {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

/*
 * Force header controls to white
 */

.lilly-header-right button,
.lilly-header-right svg {
  color: #ffffff;
}

/* =========================================================
   PROFILE
   ========================================================= */

.lilly-profile {
  position: relative;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 9px;
  padding: 0 12px;
  cursor: pointer;
  -webkit-user-select: none;
             -moz-user-select: none;
              -ms-user-select: none;
          user-select: none;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.lilly-profile:hover {
  background: rgba(255, 255, 255, 0.08);
}

.lilly-avatar {
  width: 36px;
  height: 36px;
  min-width: 36px;

  display: -webkit-box;

  display: -ms-flexbox;

  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;

  border-radius: 50%;

  background: #ffffff;
  color: #d52b1e;

  font-size: 13px;
  font-weight: 700;
}

.lilly-profile-name {
  max-width: 120px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.lilly-chevron {
  width: 16px;
  height: 16px;
  color: #ffffff !important;
}

/* =========================================================
   PROFILE DROPDOWN
   ========================================================= */

.lilly-profile-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);

  width: 330px;

  background: #ffffff;
  color: #1f2937;

  border-radius: 6px;

  border: 1px solid #e5e7eb;

  -webkit-box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.18),
    0 3px 8px rgba(0, 0, 0, 0.08);

          box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.18),
    0 3px 8px rgba(0, 0, 0, 0.08);

  overflow: hidden;

  z-index: 9999;

  cursor: default;
}

.lilly-profile-header {
  padding: 18px 20px;

  border-bottom: 1px solid #eeeeee;

  background: #fafafa;
}

.lilly-profile-title {
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lilly-profile-content {
  padding: 18px 20px;

  display: -webkit-box;

  display: -ms-flexbox;

  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 20px;
}

.lilly-profile-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 14px;
}

.lilly-profile-icon {
  width: 20px;
  height: 20px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.lilly-blue {
  color: #2563eb !important;
}

.lilly-green {
  color: #16a34a !important;
}

.lilly-profile-label {
  display: block;

  margin-bottom: 4px;

  color: #6b7280;

  font-size: 11px;
  font-weight: 700;

  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.lilly-profile-value {
  display: block;

  max-width: 240px;

  color: #1f2937;

  font-size: 13px;

  word-break: break-word;
}

.lilly-guest {
  padding: 18px;

  color: #6b7280;
  font-size: 14px;
}

/* =========================================================
   SETTINGS
   ========================================================= */

.lilly-settings {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.lilly-settings-button {
  width: 42px !important;
  height: 42px !important;

  margin: 0 !important;

  color: #ffffff !important;

  border-radius: 4px;

  -webkit-transition:
    background-color 0.2s ease,
    -webkit-transform 0.2s ease;

  transition:
    background-color 0.2s ease,
    -webkit-transform 0.2s ease;

  transition:
    background-color 0.2s ease,
    transform 0.2s ease;

  transition:
    background-color 0.2s ease,
    transform 0.2s ease,
    -webkit-transform 0.2s ease;
}

.lilly-settings-button:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.lilly-settings-button svg {
  width: 21px;
  height: 21px;

  color: #ffffff !important;
}

/* =========================================================
   NAVBAR OVERRIDES
   ========================================================= */

/*
 * These overrides are useful if NavBar has its own
 * dark background.
 */

.lilly-header-wrapper [class*='bg-primary'],
.lilly-header-wrapper [class*='bg-black'],
.lilly-header-wrapper [class*='bg-dark'] {
  background-color: #d52b1e !important;
}

/*
 * Remove unwanted borders/shadows from the existing NavBar
 */

.lilly-header-wrapper nav {
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  border-bottom: none !important;
}

/* =========================================================
   RESPONSIVE
   ========================================================= */

@media (max-width: 900px) {
  .lilly-secondary {
    display: none;
  }

  .lilly-header-center {
    max-width: 35%;
  }

  .lilly-profile-name {
    display: none;
  }
}

@media (max-width: 650px) {
  .lilly-header {
    height: 56px;
  }

  .lilly-brand-area {
    padding-left: 8px;
    padding-right: 10px;
  }

  .lilly-back-icon {
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }

  .lilly-profile {
    padding: 0 6px;
  }

  .lilly-avatar {
    width: 32px;
    height: 32px;
    min-width: 32px;
  }

  .lilly-profile-menu {
    width: min(330px, calc(100vw - 20px));
    right: 5px;
  }

  .lilly-header-center {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/Header/Header.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE;;AACF;;EAEE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;EAEE;;AACF;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,sBAAsB;EACtB,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;;;;EAIE;;AACF;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,mCAA2B;UAA3B,2BAA2B;EAC3B,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA,qDAAqD;;AACrD;;EAEE,cAAc;AAChB;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,wCAAgC;UAAhC,gCAAgC;EAChC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;;EAEE;;AACF;;EAEE,cAAc;AAChB;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,yBAAiB;aAAjB,sBAAiB;cAAjB,qBAAiB;UAAjB,iBAAiB;EACjB,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;;EAEf,oBAAa;;EAAb,oBAAa;;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;;EAEvB,kBAAkB;;EAElB,mBAAmB;EACnB,cAAc;;EAEd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;;EAEnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;;EAErB,YAAY;;EAEZ,mBAAmB;EACnB,cAAc;;EAEd,kBAAkB;;EAElB,yBAAyB;;EAEzB;;iCAE+B;;UAF/B;;iCAE+B;;EAE/B,gBAAgB;;EAEhB,aAAa;;EAEb,eAAe;AACjB;;AAEA;EACE,kBAAkB;;EAElB,gCAAgC;;EAEhC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;EAElB,oBAAa;;EAAb,oBAAa;;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;EACf,gBAAgB;;EAEhB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;;EAEd,gBAAgB;;EAEhB,cAAc;;EAEd,eAAe;;EAEf,sBAAsB;AACxB;;AAEA;EACE,aAAa;;EAEb,cAAc;EACd,eAAe;AACjB;;AAEA;;8DAE8D;;AAE9D;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;;EAEvB,oBAAoB;;EAEpB,yBAAyB;;EAEzB,kBAAkB;;EAElB;;+BAEqB;;EAFrB;;+BAEqB;;EAFrB;;uBAEqB;;EAFrB;;;+BAEqB;AACvB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;;8DAE8D;;AAE9D;;;EAGE;;AACF;;;EAGE,oCAAoC;AACtC;;AAEA;;EAEE;;AACF;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;8DAE8D;;AAE9D;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* =========================================================\n   LILLY HEADER\n   ========================================================= */\n\n.lilly-header-wrapper {\n  width: 100%;\n  position: relative;\n  z-index: 100;\n}\n\n/*\n * Main Lilly red header\n */\n.lilly-header-wrapper .navbar,\n.lilly-header-wrapper nav {\n  background: #d52b1e !important;\n  border: none !important;\n}\n\n/*\n * Header container\n */\n.lilly-header {\n  position: relative;\n  height: 64px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n  background: #d52b1e;\n}\n\n/* =========================================================\n   LEFT\n   ========================================================= */\n\n.lilly-header-left {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.lilly-brand-area {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 20px 0 12px;\n  transition: background-color 0.2s ease;\n}\n\n.lilly-clickable {\n  cursor: pointer;\n}\n\n.lilly-brand-area:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.lilly-back-icon {\n  width: 26px;\n  height: 26px;\n  margin-right: 14px;\n  color: #ffffff !important;\n  stroke-width: 2;\n}\n\n.lilly-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/*\n * Try to make the existing OHIF logo white.\n * If your custom Lilly logo already handles this,\n * these rules can be removed.\n */\n.lilly-logo svg {\n  max-height: 38px;\n  width: auto;\n  color: #ffffff;\n  fill: #ffffff;\n}\n\n/* =========================================================\n   SECONDARY\n   ========================================================= */\n\n.lilly-secondary {\n  position: absolute;\n  left: 250px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  height: 40px;\n  color: #ffffff;\n}\n\n/* Ensure secondary components don't get black text */\n.lilly-secondary,\n.lilly-secondary * {\n  color: #ffffff;\n}\n\n/* =========================================================\n   CENTER\n   ========================================================= */\n\n.lilly-header-center {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 45%;\n}\n\n.lilly-center-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #ffffff;\n}\n\n.lilly-center-content * {\n  color: #ffffff;\n}\n\n/* =========================================================\n   RIGHT\n   ========================================================= */\n\n.lilly-header-right {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding-right: 10px;\n}\n\n.lilly-control {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/*\n * Force header controls to white\n */\n.lilly-header-right button,\n.lilly-header-right svg {\n  color: #ffffff;\n}\n\n/* =========================================================\n   PROFILE\n   ========================================================= */\n\n.lilly-profile {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 0 12px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.lilly-profile:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.lilly-avatar {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n\n  background: #ffffff;\n  color: #d52b1e;\n\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.lilly-profile-name {\n  max-width: 120px;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.lilly-chevron {\n  width: 16px;\n  height: 16px;\n  color: #ffffff !important;\n}\n\n/* =========================================================\n   PROFILE DROPDOWN\n   ========================================================= */\n\n.lilly-profile-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n\n  width: 330px;\n\n  background: #ffffff;\n  color: #1f2937;\n\n  border-radius: 6px;\n\n  border: 1px solid #e5e7eb;\n\n  box-shadow:\n    0 10px 30px rgba(0, 0, 0, 0.18),\n    0 3px 8px rgba(0, 0, 0, 0.08);\n\n  overflow: hidden;\n\n  z-index: 9999;\n\n  cursor: default;\n}\n\n.lilly-profile-header {\n  padding: 18px 20px;\n\n  border-bottom: 1px solid #eeeeee;\n\n  background: #fafafa;\n}\n\n.lilly-profile-title {\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 600;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lilly-profile-content {\n  padding: 18px 20px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.lilly-profile-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.lilly-profile-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.lilly-blue {\n  color: #2563eb !important;\n}\n\n.lilly-green {\n  color: #16a34a !important;\n}\n\n.lilly-profile-label {\n  display: block;\n\n  margin-bottom: 4px;\n\n  color: #6b7280;\n\n  font-size: 11px;\n  font-weight: 700;\n\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.lilly-profile-value {\n  display: block;\n\n  max-width: 240px;\n\n  color: #1f2937;\n\n  font-size: 13px;\n\n  word-break: break-word;\n}\n\n.lilly-guest {\n  padding: 18px;\n\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* =========================================================\n   SETTINGS\n   ========================================================= */\n\n.lilly-settings {\n  display: flex;\n  align-items: center;\n}\n\n.lilly-settings-button {\n  width: 42px !important;\n  height: 42px !important;\n\n  margin: 0 !important;\n\n  color: #ffffff !important;\n\n  border-radius: 4px;\n\n  transition:\n    background-color 0.2s ease,\n    transform 0.2s ease;\n}\n\n.lilly-settings-button:hover {\n  background: rgba(255, 255, 255, 0.1) !important;\n}\n\n.lilly-settings-button svg {\n  width: 21px;\n  height: 21px;\n\n  color: #ffffff !important;\n}\n\n/* =========================================================\n   NAVBAR OVERRIDES\n   ========================================================= */\n\n/*\n * These overrides are useful if NavBar has its own\n * dark background.\n */\n.lilly-header-wrapper [class*='bg-primary'],\n.lilly-header-wrapper [class*='bg-black'],\n.lilly-header-wrapper [class*='bg-dark'] {\n  background-color: #d52b1e !important;\n}\n\n/*\n * Remove unwanted borders/shadows from the existing NavBar\n */\n.lilly-header-wrapper nav {\n  box-shadow: none !important;\n  border-bottom: none !important;\n}\n\n/* =========================================================\n   RESPONSIVE\n   ========================================================= */\n\n@media (max-width: 900px) {\n  .lilly-secondary {\n    display: none;\n  }\n\n  .lilly-header-center {\n    max-width: 35%;\n  }\n\n  .lilly-profile-name {\n    display: none;\n  }\n}\n\n@media (max-width: 650px) {\n  .lilly-header {\n    height: 56px;\n  }\n\n  .lilly-brand-area {\n    padding-left: 8px;\n    padding-right: 10px;\n  }\n\n  .lilly-back-icon {\n    width: 22px;\n    height: 22px;\n    margin-right: 8px;\n  }\n\n  .lilly-profile {\n    padding: 0 6px;\n  }\n\n  .lilly-avatar {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n  }\n\n  .lilly-profile-menu {\n    width: min(330px, calc(100vw - 20px));\n    right: 5px;\n  }\n\n  .lilly-header-center {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
